import { ApiInstance, RetrySettings } from '@src/services/api-instance';
import { getAuthToken } from '@src/services/auth-service';

import { HubWorkflowsGetResponseDTO } from './dto/hub-workflows.get.response.dto';
import { HubWorkflowsGetByIdResponseDTO } from './dto/hub-workflows.getById.response.dto';

const NO_RETRY: RetrySettings = { maxRetries: 0, retryDelay: 0, delayType: 'linear' };

export class HubWorkflowsService {
  private readonly client: ApiInstance;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/workflows`, client.getTimeout());
  }

  async get(request: { params: { organizationId: string } }): Promise<HubWorkflowsGetResponseDTO> {
    return (
      await this.client.get<HubWorkflowsGetResponseDTO>(``, request.params, {
        bearerToken: await getAuthToken(),
        settings: NO_RETRY,
      })
    ).data;
  }

  async getById(request: { id: string }): Promise<HubWorkflowsGetByIdResponseDTO> {
    return (
      await this.client.get<HubWorkflowsGetByIdResponseDTO>(
        `/${request.id}`,
        {},
        {
          bearerToken: await getAuthToken(),
          settings: NO_RETRY,
        },
      )
    ).data;
  }
}
